import { render, staticRenderFns } from "./AzulImportDetail.vue?vue&type=template&id=a5c89f12&scoped=true"
import script from "./AzulImportDetail.vue?vue&type=script&lang=js"
export * from "./AzulImportDetail.vue?vue&type=script&lang=js"
import style0 from "../ImportDetail/styles.scss?vue&type=style&index=0&id=a5c89f12&prod&scoped=true&lang=scss&external"
import style1 from "./AzulImportDetail.vue?vue&type=style&index=1&id=a5c89f12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c89f12",
  null
  
)

export default component.exports